import React from 'react';
import TimeBar from './builder/bar-time';
import VictoryBar from './builder/bar-victory';
import PalaBar from './builder/bar-pala';
import BackLink from '../../components/utils/back-link';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';

const ActionBar = () => {
  return (
    <div className="stretch">
      <BackLink />
      <Tabs className="owl">
        <TabList className="row-center align-center">
          <Tab className="pill-button txt-uppercase">Duración</Tab>
          <Tab className="pill-button txt-uppercase">Resultado</Tab>
          <Tab className="pill-button txt-uppercase">Pala</Tab>
        </TabList>
        <TabPanels>
          <TabPanel className="col-center align-center">
            <TimeBar />
          </TabPanel>
          <TabPanel className="col-center align-center">
            <VictoryBar />
          </TabPanel>
          <TabPanel>
            <PalaBar />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
};
export default ActionBar;
